import React, { useState } from 'react';

const accordionData = [
  {
    id: 1,
    title: "Why should I study abroad??",
    description: "Studying abroad offers you the opportunity to gain a world-class education, experience new cultures, develop language skills, and enhance your career prospects by building a global network.",
  },
  {
    id: 2,
    title: "How do I choose the right country and university??",
    description: "Consider factors such as your preferred course of study, tuition costs, living expenses, visa requirements, language, and career opportunities. You can also seek guidance from our education counselors.",
  },
  {
    id: 3,
    title: "How long does the application process take?",
    description:
      "The application process can take anywhere from 2 to 6 months, depending on the country and institution. It’s best to start early to meet deadlines.",
  },
  {
    id: 4,
    title: "Can I work while studying abroad?",
    description: "Yes, most countries allow students to work part-time during their studies. However, working hours are typically limited: USA: Up to 20 hours per week. UK: Up to 20 hours per week. Canada: Up to 20 hours per week. Dubai: Varies based on visa type",
  },
  {
    id: 5,
    title: "Is it safe to study abroad?",
    description: "Yes, universities prioritize student safety. However, it’s important to stay informed, follow local guidelines, and register with your country’s embassy.",
  },
  {
    id: 6,
    title: "Do I need health insurance to study abroad?",
    description: "Yes, most countries require students to have valid health insurance before starting their studies. Some universities offer their own health insurance plans.",
  },
  {
    id: 7,
    title: "Can I apply to multiple universities at the same time?",
    description: "Yes, we recommend applying to multiple universities to increase your chances of admission.",
  },
  {
    id: 8,
    title: "How can your platform help me with the application process?",
    description: "365 Global Consulting provides: Personalized university recommendations, Admission application assistance, Visa processing support, Scholarship guidance, Pre-departure orientation.",
  },
];

const Accordion = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleAccordion = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <div className="w-full container mx-auto space-y-3">
      {accordionData.map((item) => (
        <div
          key={item.id}
          className="border border-gray-neutral md:min-w-[1250px] rounded-xl"
        >
          <div
            onClick={() => toggleAccordion(item.id)}
            className="flex items-center justify-between  p-4 cursor-pointer"
          >
            <div className="flex items-center space-x-4">
              {/* <span className="text-gray-500 font-semibold">{`0${item.id}`}</span> */}
              <p className="uppercase text-base md:text-lg">{item.title}</p>
            </div>
            <span>
              {activeId === item.id ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 15l7-7 7 7"
                  />
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_126_264)">
<path d="M12 1.5V22.5M1.5 12H22.5" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_126_264">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

              )}
            </span>
          </div>
          {activeId === item.id && item.description && (
            <div className="p-4 pt-0 opacity-80 text-sm md:w-3/4 leading-relaxed">
              {item.description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
